import {EventPromoClick} from '_types'
import {analyticsLogEvent} from '_analytics/api'

const eventName = 'promoClick'

interface Parameters {
    name?: string
    id: string
    position: string
    creative: string
    promoText: string
}

/**
 * Tracks a quick cart add event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.name - Id of the page including the page designer module
 * @param {string} params.id - Name of the module on page designer
 * @param {number} params.position - Position of the module in the page.
 * @param {number} params.creative - Name of the module type.
 * @param {number} params.promoText - Text in the call to action
 */
export function analyticsEventPromoClick({id, creative, position, name, promoText}: Parameters) {
    const eventDetails: EventPromoClick = {
        ecommerce: {
            promoClick: {
                promotions: [
                    {
                        id: id,
                        creative: creative,
                        position: position,
                        name: name,
                    },
                ],
            },
            promo_text: promoText,
        },
    }

    analyticsLogEvent(eventName, eventDetails)
}
